import * as React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import InteractiveChapterPreview from './InteractiveChapterPreview';

export default function InteractiveChapterPreviewLauncher({
  open,
  onClose,
  storyID,
  chapterID,
}) {
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { bgcolor: "background.default", overflow: "hidden" } }}
    >
      <Box sx={{ position: "relative" }}>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, zIndex: 2, bgcolor: "background.paper" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {/* Give the preview a tall-ish space */}
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ height: { xs: "70vh", md: "78vh" } }}>
            <InteractiveChapterPreview
              storyID={storyID}
              chapterID={chapterID}   // pass through as doc id
              onClose={onClose}
              height="100%"
            />
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
}
